import coffeeRoast from '../assets/images/coffee_roast.png';

export default function ApplicationLogo(props) {
    return (
        <img src={coffeeRoast} width='200px' alt="Coffee Roast City" />
    );
}